import type { BasisFieldKey, FieldBasisView } from '@epc/contracts';
import { useQuery } from '@tanstack/react-query';
import { Link } from '@tanstack/react-router';
import { api } from '../lib/api';

/**
 * Основание срока или лимита в форме (БЗ-03): «Основание: регламент, п. 2.1». Ничего не показывает, пока
 * администратор не выбрал регламент для этого поля или если у человека нет доступа к базе знаний.
 */
export function FieldBasis({ field, className = '' }: { field: BasisFieldKey; className?: string }) {
  const q = useQuery({
    queryKey: ['kb', 'field-bases'],
    queryFn: () => api<FieldBasisView[]>('/kb/field-bases'),
    staleTime: 5 * 60_000,
    retry: false,
  });
  const b = q.data?.find((x) => x.fieldKey === field);
  if (!b?.articleId || b.archived) return null;
  return (
    <p className={`text-[12px] leading-4 text-ink-2 ${className}`}>
      Основание:{' '}
      <Link to="/kb/$articleId" params={{ articleId: b.articleId }} className="underline">
        {b.articleTitle}
        {b.point ? `, п. ${b.point}` : ''}
      </Link>
      {b.pointText ? ` — ${b.pointText}` : ''}
    </p>
  );
}
